import React, { useState } from "react";
import CustomSearchBox from "../../Core/CommonV2/CustomSearchBox";
import { CrossIcon, CrossIconSecondary } from "../../Core/svgV2/CrossIcon";
import { ChevronDoubleIcon, ChevronIcon } from "../../Core/svgV2/Chevron";
import { useNavigate } from "react-router-dom";

const TimeEstimatesMenu = ({ search, setSearch }) => {
  const navigate = useNavigate();
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="px-6 py-3 bg-white border-b border-gray-200">
      <div className="flex justify-between items-center">
        <div>
          <div className="text-black out-500-14">Time Estimates</div>
          <p className="mt-0.5 out-300-14 text-gray-500">
            Add the weekly time estimates for each team member within projects.
          </p>
        </div>

        <div
          className="flex gap-2 px-2.5 py-[5px] border rounded-[4px] items-center mt-[5px] h-[30px] w-[148px] whitespace-nowrap hover:bg-gray-50"
          role="button"
          onClick={() => navigate(`/reports`)}
        >
          <ChevronIcon className="rotate-90 text-gray-700 " />
          <div className="out-500-14 text-gray-700 mt-[-1px]">
            Back To Reports
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mt-3.5">
        <div className="flex items-center gap-x-4">
          <CustomSearchBox
            placeholder="Search Projects"
            width="226px"
            className={`px-[2px] w-[226px] h-[30px] ${
              isFocused ? "border-[#2E90FA]" : "border-gray-300"
            }`}
            search={search}
            setSearch={(e) => {
              setSearch(e.toLowerCase());
            }}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            suffix={
              search ? (
                <span onClick={() => setSearch("")} className="cursor-pointer">
                  <CrossIconSecondary />
                </span>
              ) : null
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TimeEstimatesMenu;
